import { useRef, useState } from "react"
import { useAsyncEffect } from "./useAsyncEffect"

export function useWatchState<T>(
  callback: (prevState: T, currentState: T, hasMounted: boolean) => any | Promise<any>,
  watchState: T,
  debounceTime?: number,
) {
  const hasMountedRef = useRef(false)
  const [prevState, setPrevState] = useState(watchState)

  async function runCallbacks() {
    await callback(prevState, watchState, hasMountedRef.current)
    hasMountedRef.current = true
    setPrevState(watchState)
  }

  const debounceRef = useRef<any>(null)
  useAsyncEffect(async () => {
    if (debounceTime) {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }
      debounceRef.current = setTimeout(runCallbacks, debounceTime)
    } else {
      await runCallbacks()
    }
  }, [JSON.stringify(watchState)])
}
